import { cardInformationLocaleTexts } from './information'

export const cardLocaleTexts = {
  information: cardInformationLocaleTexts,
}
